import type { AchievementI18N } from '../../../services/generated/Api';
import { clampLanguage, useLanguage, useLanguageStore, type Language } from '../../../stores/languageStore';

export type Lang = Language;

export const pickLang = (): Lang => clampLanguage(useLanguageStore.getState().language);

export const useAchievementLang = (): Lang => clampLanguage(useLanguage());

const localized = (i18n: AchievementI18N, lang: string): AchievementI18N['en'] => i18n[clampLanguage(lang)];

export function pickTitle(i18n: AchievementI18N | undefined, lang: string = pickLang()): string {
  if (!i18n) return '';
  return localized(i18n, lang).title;
}

export function pickDescription(i18n: AchievementI18N | undefined, lang: string = pickLang()): string {
  if (!i18n) return '';
  return localized(i18n, lang).description;
}
